import { render, staticRenderFns } from "./FranchiseNotificationCreate.vue?vue&type=template&id=7b52602b&"
import script from "./FranchiseNotificationCreate.vue?vue&type=script&lang=js&"
export * from "./FranchiseNotificationCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports